import React, { Fragment, useEffect, useState } from "react";
import {
	Box,
	Button,
	Container,
	Divider,
	IconButton,
	Tooltip,
	Typography,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AddressDataForm from "../../components/AddressDataForm";
import REGEX from "../../utils/regex";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../../context/Cart/CartContext";
import { api } from "../../services/api";
import Swal from "sweetalert2";
import { useAuth } from "../../context/Auth/AuthContext";

const AddAddressContainer = () => {
	const [newAddressDataForm, setNewAddressDataForm] = useState([
		{
			id: "clientAddressDescrp",
			element: "input",
			type: "text",
			label: "Descripción",
			value: "",
			error: "",
			regEx: REGEX.lettersAndNumbersValidator,
			regMessage: "La descripción debe contener números y letras",
		},
		{
			id: "clientAddress",
			element: "input",
			type: "text",
			label: "Dirección",
			value: "",
			error: "",
			regEx: REGEX.lettersAndNumbersValidator,
			regMessage: "La dirección debe contener números y letras",
		},
		{
			id: "clientFloor",
			element: "input",
			type: "text",
			label: "Piso",
			value: "",
			error: "",
			regEx: REGEX.floorAndApartment,
			regMessage: "El piso debe contener solo números y letras",
		},
		{
			id: "clientDoor",
			element: "input",
			type: "text",
			label: "Departamento",
			value: "",
			error: "",
			regEx: REGEX.floorAndApartment,
			regMessage: "El departamento debe contener solo números y letras",
		},
		{
			id: "clientCity",
			element: "input",
			type: "text",
			label: "Ciudad",
			value: "",
			error: "",
			regEx: REGEX.textFormatValidator,
			regMessage: "La ciudad debe contener solo letras",
		},
		{
			id: "clientZipCode",
			element: "input",
			type: "text",
			label: "Código Postal",
			value: "",
			error: "",
			regEx: REGEX.zipCode,
			regMessage: "El código postal debe tener 4 o 5 números",
		},
		{
			id: "clientStateName",
			element: "select",
			type: "text",
			label: "Provincia",
			value: "",
			error: "",
			regEx: REGEX.textFormatValidator,
			regMessage: "Debe seleccionar una provincia",
		},
	]);
	const [states, setStates] = useState([]);
	const navigate = useNavigate();
	const { cart } = useCart();
	const { userData } = useAuth();

	const dataValidation = (fn, data) => {
		let errorMessage = "";
		const newDataForm = [...data];
		newDataForm.forEach((field) => {
			field.error = !field.value.toString().match(field.regEx)
				? field.regMessage
				: "";
			errorMessage = errorMessage + field.error;
		});
		fn(newDataForm);

		return errorMessage;
	};

	const handleChangeAddress = (evt) => {
		const newDataForm = [...newAddressDataForm];
		newDataForm.forEach((dato) => {
			if (evt.target.name === dato.id) dato.value = evt.target.value;
		});
		setNewAddressDataForm(newDataForm);
	};

	const createUserData = (data) => {
		let formattedData = [];
		formattedData = data.map((el) => {
			return [...formattedData, el.id, el.value];
		});
		return Object.fromEntries(formattedData);
	};

	const saveNewAddress = (data) => {
		let error = "";

		const newUserData = createUserData(data);
		newUserData.clientId = userData.clientId;
		newUserData.userId = userData.userId;

		api.account
			.addNewUserAddress(newUserData)
			.then((data) => {
				if (data.status === 200) {
					Swal.fire({
						customClass: {
							confirmButton: "swalBtnOk",
							title: "swalTitle",
						},
						position: "left",
						icon: "success",
						title: "Se han guardado sus datos",
						width: "350px",
						showConfirmButton: true,
						focusConfirm: false,
						iconColor: "#36A160",
						color: "#292929",
						background: "#FAFAFA",
						confirmButtonColor: "rgb(230, 11, 19)",
					});
				}
				setTimeout(() => {
					navigate(-1);
				}, 2000);
			})
			.catch((err) => (error = err));

		return error;
	};

	const handleAddressSubmit = (e) => {
		e.preventDefault();
		let validatingError = "";
		validatingError = dataValidation(setNewAddressDataForm, newAddressDataForm);
		if (validatingError !== "") {
			return;
		}

		saveNewAddress(newAddressDataForm);
	};

	useEffect(() => {
		const controller = new AbortController();
		api.utilities
			.getStates(controller.signal)
			.then((res) => res.json())
			.catch((err) => console.log(err))
			.then(setStates)
			.catch((err) => console.log(err));

		return () => {
			controller.abort();
		};
	}, []);

	return (
		<Fragment>
			<Container>
				<Box display="flex" alignItems="center" minHeight="56px">
					<Box>
						<Tooltip title="Volver">
							<IconButton
								size="large"
								aria-label="volver"
								aria-controls="volver-carrito"
								aria-haspopup="false"
								color="inherit"
								onClick={() => navigate(-1)}
							>
								<ArrowBackIosIcon />
							</IconButton>
						</Tooltip>
					</Box>
					<Typography
						variant="h5"
						display="flex"
						justifyContent="center"
						alignItems="center"
						flexGrow={1}
					>
						Agregar Dirección de envío
					</Typography>
					<Box>
						<Tooltip title="Carrito">
							<Link to="/cart">
								<IconButton
									size="large"
									aria-label="carrito"
									aria-controls="logo-carrito"
									aria-haspopup="false"
									color="inherit"
								>
									{Boolean(cart?.length) ? (
										<ShoppingCartIcon color="secondary" />
									) : (
										<ShoppingCartOutlinedIcon color="secondary" />
									)}
								</IconButton>
							</Link>
						</Tooltip>
					</Box>
				</Box>
			</Container>
			<Divider />
			<Container sx={{ mt: 4 }}>
				<AddressDataForm
					dataForm={newAddressDataForm}
					handleChange={handleChangeAddress}
					states={states}
				/>
			</Container>
			<Box sx={{ display: "flex", justifyContent: "center", mb: 8 }}>
				<Button
					id="btnForm"
					type="submit"
					color="brand"
					onClick={handleAddressSubmit}
					variant="contained"
					sx={{
						width: "30%",
						minWidth: "150px",
						mt: 2,
						fontSize: "1rem",
						fontWeight: 700,
						textTransform: "none",
					}}
					style={{ fontFamily: "Quicksand" }}
				>
					Guardar
				</Button>
			</Box>
		</Fragment>
	);
};

export default AddAddressContainer;
